import { useState } from 'react'

import AccountHeader from './BillingHeader'
import BillingAlertModal from './components/modal/BillingAlertModal'
import BillingAlertsSection from './components/section/BillingAlertsSection'

import { useBillingInfo } from './useBillingInfo'
import AccountDetailsForm from './components/form/AccountDetailsForm'
import LastMonthUsageBreakup from './components/usage/LastMonthUsageBreakup'

const BillingPage = () => {
  const { data, actions, alertUpdateLoading } = useBillingInfo()

  const { updateBillingAmount } = actions
  const { billingAlertAmount } = data

  const usageData = data.cardData

  const [showAlertModal, setShowAlertModal] = useState(false)

  return (
    <>
      <AccountHeader cardData={data.cardData} />

      <BillingAlertsSection
        currentCredit={billingAlertAmount}
        onAddAlert={() => setShowAlertModal(true)}
      />

      <AccountDetailsForm />
      {usageData && <LastMonthUsageBreakup monthToDateUsage={usageData.monthToDateUsage} />}

      {/* --- Modals --- */}
      <BillingAlertModal
        showModal={showAlertModal}
        setShowModal={setShowAlertModal}
        updateBillingAmount={updateBillingAmount}
        alertUpdateLoading={alertUpdateLoading}
      />

    </>
  )
}

export default BillingPage
